import React from 'react';
import PropTypes from 'prop-types';
import { useIsLarge } from '../../../../shared/theme';
import { sinceYears } from '../../../fund/fund-components/shared-utils';
import PercentageDataFact from './percentage-data-fact';

export default function Performance(props) {
  const {
    inceptionDate,
    oneMonthReturnPercent,
    oneYearReturnPercent,
    threeYearReturnPercent,
    fiveYearReturnPercent,
    returnSinceInception,
  } = props;

  const isLarge = useIsLarge();
  const growthSinceInceptionLabel = `${isLarge ? '' : 'Growth '}Since Inception`;

  return (
    <>
      <PercentageDataFact label="1 Month" value={oneMonthReturnPercent} nullReplacement="-" clazz="first" />
      {isLarge && <PercentageDataFact label="1 Year" value={oneYearReturnPercent} nullReplacement="-" />}
      <PercentageDataFact label="3 Years" value={threeYearReturnPercent} nullReplacement="-" />
      {isLarge && <PercentageDataFact label="5 Years" value={fiveYearReturnPercent} nullReplacement="-" />}
      <PercentageDataFact
        label={growthSinceInceptionLabel}
        value={returnSinceInception}
        nullReplacement="-"
        perAnnual
        date={sinceYears(inceptionDate)}
        clazz="last"
      />
    </>
  );
}

Performance.propTypes = {
  inceptionDate: PropTypes.string.isRequired,
  oneMonthReturnPercent: PropTypes.string,
  oneYearReturnPercent: PropTypes.string,
  threeYearReturnPercent: PropTypes.string,
  fiveYearReturnPercent: PropTypes.string,
  returnSinceInception: PropTypes.string.isRequired,
};

Performance.defaultProps = {
  oneMonthReturnPercent: null,
  oneYearReturnPercent: null,
  threeYearReturnPercent: null,
  fiveYearReturnPercent: null,
};
